import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private sidenavToggleSubject = new Subject<void>();
  sidenavToggle$ = this.sidenavToggleSubject.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  toggle() {
    this.sidenavToggleSubject.next();
    console.log(this.sidenavToggle$);
  }
}
